<app-custom-dialog-modal
  [hideHeader]="true"
  [actionButtons]="actionButtons()"
  (actionClicked)="onContinue()"
>
  <div class="promo-content">
    <div class="promo-logo">
      <img src="assets/svg/dhig-logo.svg" alt="Daily Health Insurance Group" class="dhig-logo" />
    </div>

    <h2 class="promo-title">{{ 'appPromo.popup.title' | translate }}</h2>
    <p class="promo-body">{{ 'appPromo.popup.body' | translate }}</p>

    <div class="store-badges">
      @if (showAppStoreBadge()) {
        <div class="store-badge" (click)="openAppStore()">
          <img
            src="assets/svg/app_store_badge_rgb_blk.svg"
            [attr.alt]="'appPromo.storeBadges.appStoreBadgeAlt' | translate"
            class="badge-icon"
          />
        </div>
      }
      @if (showPlayStoreBadge()) {
        <div class="store-badge" (click)="openPlayStore()">
          <img
            src="assets/svg/google_play_badge_web.svg"
            [attr.alt]="'appPromo.storeBadges.playStoreBadgeAlt' | translate"
            class="badge-icon"
          />
        </div>
      }
    </div>

    <p class="promo-note">{{ 'appPromo.popup.note' | translate }}</p>
  </div>
</app-custom-dialog-modal>
